module.exports = __webpack_public_path__ + "img/LT.7fc1ec8d.svg";